import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Rx";
import Dexie from 'dexie';

import {BtLocalService} from './bt-local.service';
import {DexieService} from "./dexie.service";
import {BT, Measure, PK} from "../../models/models";

@Injectable()
export class MeasureLocalService {
  table: Dexie.Table<Measure, any>;

  constructor(private dexieService: DexieService) {
    this.table = this.dexieService.table('measures');
    this.table.mapToClass(Measure);
  }

  public static deleteCurrentMeasure(): void {
    localStorage.removeItem('currentMeasure');
  }

  public static getCurrentMeasure(): Measure {
    return JSON.parse(localStorage.getItem('currentMeasure'));
  }

  public static setCurrentMeasure(currentMeasure: Measure): void {
    localStorage.setItem('currentMeasure', JSON.stringify(currentMeasure));
  }

  public clear() {
    return this.table.clear();
  }

  public count(): Observable<number> {
    return this.toObservable(this.table.count());
  }

  public countByBt(): Observable<number> {
    let bt = BtLocalService.getBT();
    return this.toObservable(this.table
      .where('[bt.number+bt.indice]')
      .equals([bt.number, bt.indice])
      .count()
    );
  }

  public delete(measures) {
    measures.forEach(measure => this.toObservable(this.table.delete([
      measure.pk.id,
      measure.bt.number,
      measure.bt.indice
    ])));
  }

  public findByPk(pk: PK): Observable<Measure> {
    let bt = BtLocalService.getBT();
    pk = Object.assign(new PK(), pk).convertStringsToNumbers();
    return this.toObservable(this.table.get([pk.id, bt.number, bt.indice]))
      .map(measure => Object.assign(new Measure(bt), measure));
  }

  public getAllMeasures(): Observable<Measure[]> {
    return this.toObservable(this.table.toCollection().toArray());
  }

  public getDistinctBTs(): Observable<BT[]> {
    return this.toObservable(this.table.orderBy('[bt.number+bt.indice]').uniqueKeys())
      .map(bts => bts.map(bt => new BT(bt[0], bt[1])));
  }

  public put(measure: Measure) {
    measure.bt = Object.assign(new BT(), measure.bt);
    measure.convertStringsToNumbers();
    return this.toObservable(this.table.put(measure));
  }

  private toObservable(dexiePromise) {
    return Observable.fromPromise(Promise.resolve(dexiePromise));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/local-data-services/measure-local.service.ts